import React from "react";
import cn from "classnames";

import { RegularText, MediumText } from "components/Text";
import { Button } from "components/Button";

import styles from "./styles.module.scss";

export const Spinner = ({ size = 24, className }) => (
  <span
    className={cn(styles.spinner, className)}
    style={{ width: size, height: size }}
  />
);

/** Центрированная загрузка для контентных областей */
export const LoadingView = ({ title = "Загрузка...", height }) => (
  <div className={styles.stateView} style={{ height }}>
    <Spinner size={28} />
    <MediumText color="muted">{title}</MediumText>
  </div>
);

/** Вывод ошибки с кнопкой повтора */
export const ErrorView = ({ message = "Что-то пошло не так", onRetry, height }) => (
  <div className={styles.stateView} style={{ height }}>
    <RegularText color="danger" size={14} className={styles.errorMessage}>
      {message}
    </RegularText>
    {!!onRetry && (
      <Button variant="tertiary" icon="refresh" onClick={onRetry}>
        Повторить
      </Button>
    )}
  </div>
);

/** Пустой список */
export const EmptyView = ({ title = "Пусто.", height }) => (
  <div className={styles.stateView} style={{ height }}>
    <RegularText color="muted">{title}</RegularText>
  </div>
);
